import React from 'react';
import { ValidationResult, RadioGroupOptions, RadioOptionsByName, RadioGroupData } from '@myriadgenetics/mgh-types';
import { Radio, RadioGroup as RacRadioGroup } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import './radio.scss';
import InputLabel from '../../../elements/input-label';
import { CleanedRadioGroupOption, OPTION_VALUES_MAPPING } from './constants';

interface RadioGroupProps {
  compDef: any;
  className?: string;
  responses: Record<string, any>;
  onResponseUpdated: (answerKey: string, val: CleanedRadioGroupOption[] | boolean) => void;
  validationResult?: ValidationResult;
  isDisabled?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({ compDef, onResponseUpdated, className, responses, isDisabled }) => {
  const componentData = compDef as any;
  const { t } = useTranslation();
  const { answerKey, radioOptions, labelKey, tipTitle, tipDescription }: RadioGroupData = componentData?.data;

  const groupRadioOptionsByName = (options: RadioGroupOptions[]) => {
    const optionKeys = [...new Set(options?.map((option) => option.optionKey))];
    const radioOptionsByName: RadioOptionsByName = {};

    optionKeys.forEach((optionKey) => {
      const optionsByKey = options.filter((option) => option.optionKey === optionKey);
      radioOptionsByName[optionKey] = optionsByKey;
    });

    return radioOptionsByName;
  };

  const radioOptionsByName = groupRadioOptionsByName(radioOptions);

  const getOptionFromValue = (value: string) => {
    return radioOptions.find((option) => option.optionValue === value) as RadioGroupOptions;
  };

  const onChange = (value: string) => {
    // Filter out extra properties for responses
    // const answerValue = OPTION_VALUES_MAPPING[value] !== undefined ? OPTION_VALUES_MAPPING[value] : value;
    if (OPTION_VALUES_MAPPING[value] !== undefined) {
      onResponseUpdated(answerKey, OPTION_VALUES_MAPPING[value]);
    } else {
      const { optionLabel, ...cleanedRadioOption } = getOptionFromValue(value);
      onResponseUpdated(answerKey, [cleanedRadioOption]);
    }
  };

  return (
    <div className={`radio-wrapper ${className ?? ''}`}>
      {Boolean(labelKey) && (
        <InputLabel asterisk tipTitle={tipTitle} tipDescription={tipDescription}>
          {t(labelKey || '')}
        </InputLabel>
      )}
      <RacRadioGroup
        key={t('personDemographic.sex')}
        className={'radio-group'}
        onChange={onChange}
        value={responses?.[answerKey]?.[0]?.optionValue}
        isDisabled={isDisabled}
      >
        {Object.keys(radioOptionsByName).map((radioOptionName) =>
          radioOptionsByName[radioOptionName].map((radioOption) => (
            <Radio className="react-aria-Radio text-medium--medium" key={radioOption.optionValue} value={radioOption.optionValue}>
              {t(radioOption.optionLabel)}
            </Radio>
          )),
        )}
      </RacRadioGroup>
    </div>
  );
};

export default RadioGroup;
